import { render } from "./VersionText.vue?vue&type=template&id=592df316&ts=true"
import script from "./VersionText.vue?vue&type=script&lang=ts"
export * from "./VersionText.vue?vue&type=script&lang=ts"

import "./VersionText.vue?vue&type=style&index=0&id=592df316&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__